import { Component, NgZone, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PaymentReference } from '../../../models/orderModel';
import { DynamicScriptLoaderService } from '../../../services/dynamicScriptLoader.service';
import { ShuttelbussService } from '../../../services/shuttlebuss.service';

declare var payex: any;
@Component({
  selector: 'app-checkout-page',
  templateUrl: './checkout-page.component.html',
  styleUrls: ['./checkout-page.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CheckoutPageComponent implements OnInit, OnDestroy {
  orderId: string;
  payexCreditcardUrl = '';
  payexSwishUrl = '';
  payexCreditcardLoaded = false;
  payexSwishLoaded = false;
  isLoading = false;
  showPayment = false;
  componentDestroyed$: Subject<boolean> = new Subject();
  loaded = false;

  constructor(
    public shuttleBussService: ShuttelbussService,
    private dynamicScriptLoaderService: DynamicScriptLoaderService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private ngZone: NgZone
  ) { }

  ngOnInit(): void {
    this.getOrderId();
    this.checkOrderStatus();
  }

  getOrderId() {
    this.activatedRoute.params.pipe(takeUntil(this.componentDestroyed$)).subscribe(params => {
      this.orderId = params['orderId'];
    });
  }

  checkOrderStatus() {
    this.shuttleBussService
      .getOrder(this.orderId)
      .pipe(takeUntil(this.componentDestroyed$))
      .subscribe(order => {

        var org = order.organizationName?.toLowerCase() || 'flygets';
        if (org == "flygets.se" || org == "tui" || org == "nazar" || org == "ving") {
          org = "flygets";
        }
        if (org == "quality hotel arlanda xpo parkering" || org == "quality-xpo-arlanda" || org == "quality") {
          org = "quality";
        }
        if (org == "aiden hotel arlanda parkering" || org == "aiden-short-term" || org == "aiden") {
          org = "aiden"
        }

        if (order.status !== 'New' && order.status !== 'Checkout' && order.status !== 'CheckoutAdditional' && order.status !== 'DriveUp') {
          window.location.href = `/parkifly/${org}/checkout/receipt/${order.orderId}/NONE`;
        } else if (order.status === 'New') {
          this.shuttleBussService
            .createCartOrder(order.orderId)
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe(paymentReference => {
              this.loadScripts(paymentReference);
            });
          this.loaded = true;
        } else if (order.status == 'Checkout' || order.status == 'CheckoutAdditional' || order.status == 'DriveUp') {
          window.location.href = `/parkifly/${org}/checkout/payment/${order.orderId}`;
          this.loadScripts(JSON.parse(order?.paymentReference));
          this.loaded = true;
        }
      });
  }

  selectedTabChange(selectedtab: number) {
    if (selectedtab === 0) {
      this.dynamicScriptLoaderService
        .load(this.payexSwishUrl)
        .then(() => {
          if (!this.payexSwishLoaded) {
            payex.hostedView
              .swish({
                container: 'swedbank-pay-seamless-view-page-swish'
              })
              .open();
            this.payexSwishLoaded = true;
          }
        })
        .catch(error => console.error(error));
    }

    if (selectedtab === 1) {
      this.dynamicScriptLoaderService
        .load(this.payexCreditcardUrl)
        .then(() => {
          if (!this.payexCreditcardLoaded) {
            payex.hostedView
              .creditCard({
                container: 'swedbank-pay-seamless-view-page-creditcard',
                onPaymentCompleted: (event: any) => {
                  this.ngZone.run(() => {
                    this.router.navigate([`parkifly/flygets/checkout/receipt/${this.orderId}/NONE`]);
                  });
                }
              })
              .open();
            this.payexCreditcardLoaded = true;
          }
        })
        .catch(error => console.error(error));
    }
  }

  private loadScripts(paymentReference: PaymentReference) {
    this.payexSwishUrl = paymentReference[0].operations[2].href;
    this.payexCreditcardUrl = paymentReference[1].operations[2].href;
    this.dynamicScriptLoaderService.addScript(this.payexCreditcardUrl);
    this.dynamicScriptLoaderService.addScript(this.payexSwishUrl);
    this.dynamicScriptLoaderService
      .load(this.payexSwishUrl)
      .then(data => {
        payex.hostedView
          .swish({
            // The container specifies which id the script will look for to host the iframe component.
            container: 'swedbank-pay-seamless-view-page-swish',
            onPaymentCompleted: (event: any) => {
              this.ngZone.run(() => {
                this.router.navigate([`parkifly/flygets/checkout/receipt/${this.orderId}/NONE`]);
              });
            }
          })
          .open();
        this.payexSwishLoaded = true;
        // Script Loaded Successfully
      })
      .catch(error => console.error(error));
  }

  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
